import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPrioritySchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-priority-schemes',
	path: '/jira/settings/issues/priority-schemes',
};
